import { useQuery } from '@tanstack/react-query'
import { tagApi } from '../api/tagApi'

export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: tagApi.getAllTags,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
}

export function useTag(tagId: number) {
  return useQuery({
    queryKey: ['tag', tagId],
    queryFn: () => tagApi.getTag(tagId),
    enabled: !!tagId,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
}

